import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from 'app';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import detectHeadlessBrowser from 'helpers/detectHeadlessBrowser';
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom';

const isHeadlessBrowser = detectHeadlessBrowser();
const headlessBrowserSharedContextKey = 'headless-browser';

(async () => {
  const initialContext = {
    kind: 'user',
    anonymous: true,
    key: isHeadlessBrowser ? headlessBrowserSharedContextKey : undefined,
  };
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LD_CLIENT_SIDE_ID || '',
    options: {
      streaming: true,
    },
    context: initialContext,
    reactOptions: {
      useCamelCaseFlagKeys: true,
    },
  });

  const router = createBrowserRouter(
    createRoutesFromElements(<Route path="*" element={<App />} />)
  );

  const container = document.getElementById('root');
  if (!container) throw new Error('Failed to find the root element');
  const root = createRoot(container);

  root.render(
    <LDProvider>
      <RouterProvider router={router} />
    </LDProvider>
  );
})();
